"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DozukiFooter = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var DozukiFooter = function (_a) {
    var siteTitle = _a.siteTitle, siteDomain = _a.siteDomain, footerLinks = _a.footerLinks, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? react_1.Link : _b, _js = _a._js, version = _a.version;
    var footerLinkOptions = __assign({ about: true, help: true, privacy: true }, footerLinks);
    var footerLinkUrls = {
        about: '/info',
        help: '/help',
        privacy: 'https://help.dozuki.com/Info/Privacy',
        contribute: '/contribute',
        api: '/api',
        licensing: 'https://help.dozuki.com/Info/Licensing',
    };
    var year = new Date().getFullYear();
    return (React.createElement(react_1.Flex, { as: "footer", paddingBlock: "30px 80px", direction: "column", justify: "center", alignItems: "center", className: "main-footer" },
        React.createElement(react_1.Flex, { gap: "4", justify: "center", className: "footer-row__top" }, Object.keys(footerLinkOptions).map(function (key) {
            return footerLinkOptions[key] && (React.createElement(LinkComponent, { key: key, href: footerLinkUrls[key], className: "footer-link__".concat(key) },
                React.createElement(react_1.Text, { color: "black", m: "0", variant: "title", fontSize: "md", textTransform: "uppercase" }, key)));
        })),
        React.createElement(react_1.Text, { color: "gray.400", fontSize: "md", textTransform: "uppercase", mt: "2", className: "footer-row__bottom" },
            _js('Powered by '),
            React.createElement(LinkComponent, { href: "https://www.dozuki.com" }, _js('Dozuki')),
            " - ",
            year,
            ' ',
            React.createElement(LinkComponent, { href: "https://".concat(siteDomain) }, siteTitle),
            " | ",
            version)));
};
exports.DozukiFooter = DozukiFooter;
